import { useContext } from "react"
import { EditorContext } from "@tiptap/react"
import type { Editor } from "@tiptap/react"

// Унифицированный хук для доступа к инстансу редактора Tiptap.
// Использует тот же контекст, который пробрасывается в SimpleEditor через EditorContext.Provider.
export function useTiptapEditor(): Editor | null {
  // EditorContext в tiptap v3 хранит объект вида { editor }
  const ctx = useContext(EditorContext as unknown as React.Context<{ editor: Editor | null } | null>)
  return ctx?.editor ?? null
}
